<template>
    <div class="Order">
        <div class="Upload">
            <el-button class="MarLe" type="primary" size="mini"
                @click="DownFile('api/user/recommenDownload')">下载模板</el-button>
            <el-button class="MarLe" type="primary" size="mini" @click="ReviewMoBan = true">文件</el-button>
        </div>
        <div class="Search">
            <el-input class="SearchWid" size="medium" placeholder="姓名" v-model="Search.name"></el-input>
            <el-input class="SearchWid" size="medium" placeholder="联系电话" v-model="Search.mobile"></el-input>
            <el-select class="SearchWid" size="medium" placeholder="审核状态" v-model="Search.status">
                <el-option label="全部" value="0"></el-option>
                <el-option label="未审核" value="1"></el-option>
                <el-option label="已通过" value="2"></el-option>
                <el-option label="未通过" value="3"></el-option>
            </el-select>
            <el-button class="ColorBlue" size="medium" @click="Query()">查询</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column cell-class-name="custom-text-size" width="100" label="序号">
                <template slot-scope="scope">
                    <span>{{ (page - 1) * SizePage + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="name" label="姓名"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="mobile" label="联系电话"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" width="200" prop="user_group_info"
                label="注册类型"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" prop="status_info"
                label="审核状态"></el-table-column>
            <el-table-column cell-class-name="custom-text-size" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" @click="LockInfo(scope.row)">
                        {{scope.row.status == 1 ? '去审核' : '详情'}}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="PageDis">
            <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"
                @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page"
                :hide-on-single-page="false"></el-pagination>
        </div>
        <el-dialog title="详情" :visible.sync="ReviewBlon" width="60%" :show-close="true" @close="LockBlon = false">
            <div class="CommDig">
                <table width="100%" class="Table" v-if="reviewInfo">
                    <tbody>
                        <tr>
                            <td width="10%"><span class="Red">*</span>姓名</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.name" disabled></el-input></td>
                            <td width="10%"><span class="Red">*</span>手机号</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.mobile" disabled></el-input>
                            </td>
                            <td colspan="2">
                                <label style="margin-right: 10px;"><span class="Red">*</span>是否向公众公布您的联系方式</label>
                                <el-radio-group disabled v-model="reviewInfo.is_public" size="small">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="2">否</el-radio>
                                </el-radio-group>
                            </td>
                        </tr>
                        <tr>
                            <td width="10%"><span class="Red">*</span>性别</td>
                            <td width="23%">
                                <el-radio-group v-model="reviewInfo.gender" disabled size="small">
                                    <el-radio label="1">男</el-radio>
                                    <el-radio label="2">女</el-radio>
                                </el-radio-group>
                            </td>
                            <td><span class="Red">*</span>出生年月</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.birthday" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>籍贯</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.native_place" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>民族</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.nation" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>身份证号码</td>
                            <td><el-input size="small" v-model="reviewInfo.id_card" disabled></el-input></td>
                            <td><span class="Red">*</span>政治面貌</td>
                            <td><el-input size="small" v-model="reviewInfo.political_party" disabled></el-input></td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>学历</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.qualification" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>学位</td>
                            <td><el-input size="small" v-model="reviewInfo.degree" disabled></el-input></td>
                            <td><span class="Red">*</span>专业</td>
                            <td><el-input size="small" v-model="reviewInfo.major" disabled></el-input></td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>技术职称</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.work_title" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>工作单位</td>
                            <td colspan="3"><el-input size="small" v-model="reviewInfo.pf_work" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>通信地址</td>
                            <td colspan="5">
                                <div class="TableDis">
                                    <el-input size="small" placeholder="请输入详细地址" v-model="reviewInfo.address"
                                        disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>简介</td>
                            <td colspan="5"><el-input size="small" type="textarea" :rows="2"
                                    v-model="reviewInfo.synopsis" disabled></el-input></td>
                        </tr>
                    </tbody>
                </table>
                <div style="text-align: center; margin-top: 20px;" v-if="reviewInfo.status == 1">
                    <el-radio-group v-model="auditStatus" size="small">
                        <el-radio :label="2">通过</el-radio>
                        <el-radio :label="3">不通过</el-radio>
                    </el-radio-group>
                    <div style="margin-top: 15px;">
                        <el-button type="primary" size="small" @click="handleConfirm" :disabled="!auditStatus">确认</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="上传模版" :visible.sync="ReviewMoBan" width="40%" :show-close="true" @close="ReviewMoBan = false">
            <div class="CommDig">
                <div class="MoBan" v-for="(item, index) in RoleList" :key="index">
                    <div>{{ item.name }}</div>
                    <el-upload action="none" size="small" multiple :show-file-list="false"
                        :http-request="(file) => UpFile(file, item.id)">
                        <el-button class="MarLe" type="primary" size="mini">导入</el-button>
                    </el-upload>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            Search: {
                name: "",
                mobile: "",
                status: "",
            },
            tableData: [],
            total: 0,
            page: 1,
            SizePage: 10,
            ReviewBlon: false,
            reviewInfo: {},
            ReviewMoBan: false,
            RoleList: [],
            currentId: null,
            auditStatus: null,
        }
    },
    mounted() {
        this.getData();
        this.getRole();
    },
    methods: {
        getData() {
            let params = {
                page: this.page,
                limit: this.SizePage,
            }
            this.$post("api/user/MyInformationList", { ...params, ...this.Search }).then(res => {
                if (res.data.code == 1) {
                    this.total = res.data.data.total;
                    res.data.data.data.forEach(item => {
                        if(item.status == 1) {
                            item.status_info = '未审核';
                        } else if(item.status == 2) {
                            item.status_info = '已通过';
                        } else if(item.status == 3) {
                            item.status_info = '未通过';
                        }
                        item.user_group_info = '';
                        if (item.user_group.length > 0) {
                            item.user_group_info = item.user_group[0].name;
                        }
                    });
                    this.tableData = res.data.data.data;
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        getRole() {
            this.$get("api/user/MyInformationRole").then(res => {
                if (res.data.code == 1) {
                    console.log(res.data)
                    this.RoleList = res.data.data;
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        Query() {
            this.getData();
        },
        LockInfo(row) {
            this.$get(`api/user/MyInformationDetails?id=${row.register_professional_id}`).then(res => {
                if (res.data.code == 1) {
                    this.ReviewBlon = true;
                    this.reviewInfo = res.data.data;
                    this.reviewInfo.status = row.status;
                    this.currentId = row.id;
                    this.auditStatus = null;
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        UpFile(file, id) {
            console.log(file)
            var fd = new FormData()
            fd.append('file_stu', file.file);
            fd.append('type', id);
            this.$post("api/user/recommenUpload", fd)
                .then((res) => {
                    if (res.data.code == 1) {
                        console.log(res.data)
                        this.ReviewMoBan = false;
                        this.getData();
                        // this.$message.success(res.data.msg)
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            this.$forceUpdate();
        },
        DownFile(res) {
            this.$get("api/user/recommenDownload").then(res => {
                if (res.data.code == 1) {
                    window.open(this.$Global.CommImgHttp + res.data.data)
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        Confirm(row) {
            this.$confirm('是否确认通过审核', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('api/user/MyInformationConfirm', {
                    id: row.id,
                    status: 2,
                }).then((res) => {
                    if (res.data.code == 1) {
                        this.$message({ message: res.data.msg, type: 'success' });
                        this.getData();
                    } else {
                        this.$message({ message: res.data.msg, type: 'error' });
                    }
                })
            })
        },
        ReviewSuc() {
            this.LockInfo();
        },
        SizeChange(val) {
            this.SizePage = val;
            this.getData();
        },
        PageChange(val) {
            this.page = val;
            this.getData();
        },
        handleConfirm() {
            if (!this.auditStatus) {
                this.$message.warning('请选择审核结果');
                return;
            }
            let statusText = this.auditStatus === 2 ? '通过' : '不通过';
            this.$confirm(`是否确认${statusText}该审核？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$post('api/user/MyInformationConfirm', {
                    id: this.currentId,
                    status: this.auditStatus,
                }).then((res) => {
                    if (res.data.code == 1) {
                        this.$message({ message: res.data.msg, type: 'success' });
                        this.ReviewBlon = false;
                        this.getData();
                    } else {
                        this.$message({ message: res.data.msg, type: 'error' });
                    }
                })
            }).catch(() => {})
        },
    },
}
</script>
<style scoped>
.Upload {
    display: flex;
    margin-bottom: 10px;
}

.Upload .MarLe {
    margin-right: 20px;
}

.ColorBlue {
    background-color: #027cfb;
    color: #fff;
}

.custom-text-size {
    font-size: 16px;
}

.Search {
    display: flex;
    align-items: center;
}

.SearchWid {
    width: 200px;
    margin-right: 10px;
}

.NavMsg {
    color: #666;
    font-size: 16px;
}

.PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.CommDig {
    max-height: 600px;
    overflow: auto;
}

.Table {
    width: 99%;
    margin: 10px auto;
    border-radius: 5px;
    border-collapse: collapse;
}

.Table td {
    border: 1px solid #e4eaec;
    padding: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}

.Table .State {
    padding-right: 10px;
}

.Table .Th {
    color: #000000;
    font-size: 16px;
    padding: 10px;
    font-weight: 700;
}

.Table td .Red {
    color: #d51938;
    font-weight: 700;
    vertical-align: middle;
    /* margin-right: 10px; */
}

.Table .TableDis {
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.MoBan {
    display: flex;
    justify-content: space-between;
    width: 70%;
    margin: 0 auto 20px auto;
    font-size: 16px;
}
</style>